import {
  PopupMenuHeader,
  PopupMenuItem,
  PopupMenuItemSeparator,
} from 'articleEditor/components/popupMenu/popupMenu';
import { isMenuHeading, MenuOption } from 'articleEditor/utils/actions';

type MenuItemProps = {
  menuItem: MenuOption;
  onSelect: (value: MenuOption) => void;
};

export const BlockMenuItem = ({
  menuItem,
  onSelect,
}: MenuItemProps): JSX.Element => {
  if (isMenuHeading(menuItem)) {
    return (
      <>
        <PopupMenuItemSeparator />
        <PopupMenuHeader label={menuItem.label} />
      </>
    );
  }

  return (
    <PopupMenuItem
      onSelect={() => onSelect(menuItem)}
      icon={menuItem.icon}
      isSelected={menuItem.isSelected}
      className={menuItem.className}
      label={menuItem.label}
    />
  );
};
